import { render, staticRenderFns } from "./rewardSetting.vue?vue&type=template&id=20952b84&scoped=true"
import script from "./rewardSetting.vue?vue&type=script&lang=js"
export * from "./rewardSetting.vue?vue&type=script&lang=js"
import style0 from "./rewardSetting.vue?vue&type=style&index=0&id=20952b84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20952b84",
  null
  
)

export default component.exports